import { SUPPLIER_TYPES, PRODUCT_TYPES } from "./TYPES";

export const supplierTypeToProductTypeMap = {
  [SUPPLIER_TYPES.HOTEL]: PRODUCT_TYPES.ROOM,
  [SUPPLIER_TYPES.RESTAURANT]: PRODUCT_TYPES.MEAL,
  [SUPPLIER_TYPES.EXCURSION]: PRODUCT_TYPES.EXCURSION,
  [SUPPLIER_TYPES.TOUR_GUIDE]: PRODUCT_TYPES.TOUR,
  [SUPPLIER_TYPES.TRANSPORT]: PRODUCT_TYPES.TRANS,
  [SUPPLIER_TYPES.PARK]: PRODUCT_TYPES.EXPENSE,
};

export const productTypeToSupplierTypeMap = {
  [PRODUCT_TYPES.ROOM]: SUPPLIER_TYPES.HOTEL,
  [PRODUCT_TYPES.MEAL]: SUPPLIER_TYPES.RESTAURANT,
  [PRODUCT_TYPES.EXCURSION]: SUPPLIER_TYPES.EXCURSION,
  [PRODUCT_TYPES.TOUR]: SUPPLIER_TYPES.TOUR_GUIDE,
  [PRODUCT_TYPES.TRANS]: SUPPLIER_TYPES.TRANSPORT,
  [PRODUCT_TYPES.EXPENSE]: SUPPLIER_TYPES.PARK,
};

export const productTypeToDbKeyMap = {
  [PRODUCT_TYPES.ROOM]: "hotels",
  [PRODUCT_TYPES.MEAL]: "restaurants",
  [PRODUCT_TYPES.EXCURSION]: "excursions",
  [PRODUCT_TYPES.TOUR]: "tour_guides",
  [PRODUCT_TYPES.TRANS]: "transport",
  [PRODUCT_TYPES.EXPENSE]: "parks",
};

export const supplierTypeToDbKeyMap = {
  [SUPPLIER_TYPES.HOTEL]: "hotels",
  [SUPPLIER_TYPES.RESTAURANT]: "restaurants",
  [SUPPLIER_TYPES.EXCURSION]: "excursions",
  [SUPPLIER_TYPES.TOUR_GUIDE]: "tour_guides",
  [SUPPLIER_TYPES.TRANSPORT]: "transport",
  [SUPPLIER_TYPES.PARK]: "parks",
};
